export default class TrustedForm {
  constructor() {
    this.field = 'homegaugeTrustedFormCertUrl';
    const provideReferrer = false;
    const invertFieldSensitivity = false;
    const sandbox = process.env.VUE_APP_NODE_ENV !== 'production';
    const tf = document.createElement('script');
    tf.classList.add('__trusted_form__');
    tf.type = 'text/javascript';
    tf.async = true;
    tf.src = `${
      document.location.protocol
    }//api.trustedform.com/trustedform.js?provide_referrer=${provideReferrer}&field=${
      this.field
    }&l=${new Date().getTime()
      + Math.random()}&invert_field_sensitivity=${invertFieldSensitivity}&sandbox=${sandbox}`;
    document.head.appendChild(tf);
  }

  getTrustedFormCertificateUrl() {
    try {
      return document.querySelector(`input[name="${this.field}"]`).value;
    } catch (err) {
      return null;
    }
  }
}
